import EnelXGui from 'gui-com-lib';
// import EnelXGui from 'remoteGui/EnelXGui'; // uncomment this for module federation

export const {
  EnelXGridSystem,
  EnelXGuiAtoms,
  EnelXGuiComponents,
  EnelXGuiConsts,
  EnelXGuiDsyuiComponents,
  EnelXGuiIcons,
  EnelXGuiPropTypes,
  EnelXGuiTemplates,
  EnelXGuiTypography,
  EnelXGuiUtils,
} = EnelXGui;

export default EnelXGui;
